import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button, Modal, ModalBody } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import Toggle from "react-toggle";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Checkbox, TextareaAutosize, TextField } from "@mui/material";

import { format } from "date-fns";
import NavbarNew from "../../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const ViewDamageDeviceDetails = ({ history, match }) => {
  const [dap_device, setDevice] = useState({
    deviceName: "",
    deviceLabel: "",
    deviceType: "",
    deviceVersion: "",
    accessToken: "",
    deviceLon: "",
  });
  const [deviceId, setDeviceId] = useState("");
  const [d_id, setId] = useState("");

  // const [deviceName, setDeviceName] = useState("")
  // const [deviceLabel, setDeviceLabel] = useState("")
  // const [deviceType, setDeviceType] = useState("")
  // const [deviceVersion, setDeviceVersion] = useState("")

  const [dap_customer, setCustomer] = useState({
    userFirstName: "",
    userLastName: "",
    industry: "",
    city: "",
  });
  const [dap_partner, setPartner] = useState({
    userFirstName: "",
    userLastName: "",
  });

  const [show, setShow] = useState(false);

  const { SearchBar } = Search;

  const [choosePartner, setChoosePartner] = useState({});
  const [goBackLink, setGoBackLink] = useState("");
  const [allPartner, setAllPartner] = useState([]);
  const [location, setLocation] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [displayUnassign, setDisplayUnassign] = useState("none");

  const [journeyData, setJourneyData] = useState([]);

  let location_array = [];
  location_array = [
    {
      locationName: "Healthcare",
      locationId: 1,
    },
    {
      locationName: "Education",
      locationId: 2,
    },
    {
      locationName: "Manufacturing",
      locationId: 3,
    },
    {
      locationName: "Hospitality",
      locationId: 4,
    },
    {
      locationName: "Corporate",
      locationId: 5,
    },
    {
      locationName: "None",
      locationId: 10,
    },
  ];

  useEffect(() => {
    let id = match.params.id;
    //  console.log(id);getLead(id);

    // if(localStorage.getItem('isLeadExecutive')){
    //   setGoBackLink("/devices")
    // }else{
    //   setGoBackLink("/devices")
    // }
    setGoBackLink("/partner-damaged-devices");
    setId(id);
    console.log("hii");
    console.log(id);

    axios
      .get(environment.dap_url + "dapDevice/viewAsset?id=" + id)
      .then((res) => {
        console.log(res.data[0].customer_details);
        console.log(res.data[0]);
        if (res.data) {
          setDevice(res.data[0]);
          setAccessToken(res.data[0].accessToken);
          setLocation(res.data[0].deviceLon);
          setDeviceId(res.data[0].deviceId);
          if (res.data[0].customer_details.length == 1) {
            // if(res.data[0].customer_details.length==1){
            setCustomer(res.data[0].customer_details[0]);
            // setLocation(res.data[0].deviceLon)
            // }
          }
          if (res.data[0].isAssignedToCustomer == true) {
            setDisplayUnassign("block");
          } else {
            setDisplayUnassign("none");
          }
          if (res.data[0].TenantDetails.length == 1) {
            setPartner(res.data[0].TenantDetails[0]);
            setChoosePartner({
              id: res.data[0].TenantDetails[0].id,
              label: res.data[0].TenantDetails[0].label,
              value: res.data[0].TenantDetails[0].value,
            });
          }
          // axios.get(environment.dap_url+ 'dapDevice/deviceJourney?deviceLabel='+res.data[0].deviceLabel).then(resDevice=>{
          //     console.log("hii")
          //     console.log(resDevice.data)
          //     setJourneyData(resDevice.data)
          // })
        }
      });

    axios
      .get(environment.dap_url + `partnerApi/getAll`)
      .then((res) => {
        console.log(res.data);
        setAllPartner(res.data);
      })
      .catch(function (error) {
        window.alert(error.message);
      });
  }, []);

  //   const columns = [
  //     {
  //       dataField: "sl.no",
  //       text: "Sl no.",
  //       formatter: (cell, row, rowIndex, formatExtraData) => {
  //         return rowIndex + 1;
  //       },
  //       sort: true,
  //     },
  //     {
  //       dataField: "createdAt",
  //       text: "Date",
  //       sort: true,
  //       formatter: (dataField) => {
  //         let dateArr = dataField.split("T")[0].split("-")
  //         return (dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0])
  //       }
  //     },
  //     {
  //       dataField: "statusText",
  //       text: "Status",
  //       sort: true,

  //     },
  //     {
  //       dataField: "_id",
  //       text: "Customer",
  //       sort: true,
  //       formatter: (row,cell,rowIndex,formatter)=>{
  //         if(journeyData[rowIndex].customer_details.length==1){
  //           return journeyData[rowIndex].customer_details[0].userFirstName+" "+journeyData[rowIndex].customer_details[0].userLastName
  //         }else{
  //           return "";
  //         }
  //       }
  //     },
  //     {
  //       dataField: "deviceInstalledPlace",
  //       text: "City",
  //       sort: true,
  //     //   formatter:(dataField)=>{
  //     //     let dateTimeArr = dataField.split("T");
  //     //     let dateArr = dateTimeArr[0].split("-")
  //     //     let dateFinal = dateArr[2]+"-"+dateArr[1]+"-"+dateArr[0];
  //     //     return (
  //     //       dateFinal
  //     //     );
  //     //   }
  //     },
  //     {
  //         dataField: "lat",
  //         text: "Latitude",
  //         sort: true,
  //       },
  //       {
  //         dataField: "long",
  //         text: "Longitude",
  //         sort: true,
  //       },
  //   ];

  //   const defaultSorted = [
  //     {
  //       dataField: "id",
  //       order: "asc",
  //     },
  //   ];

  const unAssignDevice = (e, id) => {
    let partnerToken = localStorage.getItem("token");
    console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(d_id);
        console.log(deviceId);
        console.log(partnerToken);
        axios
          .post(environment.dap_url + "dapDevice/unassignDevices?_id=" + d_id, {
            deviceId: deviceId,
            token: partnerToken,
          })
          .then((res) => {
            console.log(res);
            if (res.data) {
              MySwal.fire({
                title: "Device Unassigned",
                icon: "success",
                type: "success",
              });
              history.push("/partner-damaged-devices");
            }
          })
          .catch((err) => {
            MySwal.fire({
              title: "Error Occured",
              icon: "error",
              type: "error",
            });
          });
      }
    });
  };

  return (
    <div>
      <div className="container-fluid">
        <NavbarNew />
        <div
          class="col"
          style={{ display: "inline-flex", flexDirection: "row-reverse" }}
        >
          <Button
            onClick={(e) => {
              unAssignDevice(e, deviceId);
            }}
            className="btn btn-danger m-1"
            style={{ display: displayUnassign }}
          >
            Unassign Device
          </Button>
          <Link to={goBackLink} className="btn btn-light m-1">
            Go Back
          </Link>
        </div>
      </div>

      <div className="container-fluid">
        <h4>Device Details</h4>
        <div className="row">
          <div className="col-6">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th>Device Name</th>
                  <td>{dap_device.deviceName}</td>
                </tr>
                <tr>
                  <th>Device Label</th>
                  <td>{dap_device.deviceLabel}</td>
                </tr>
                <tr>
                  <th>Device Category</th>
                  <td>{dap_device.deviceType}</td>
                </tr>
                <tr>
                  <th>Device Model</th>
                  <td>{dap_device.deviceVersion}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-6">
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th>Partner</th>
                  <td>
                    {dap_partner.userFirstName + " " + dap_partner.userLastName}
                  </td>
                </tr>
                <tr>
                  <th>Customer</th>
                  <td>
                    {dap_customer.userFirstName +
                      " " +
                      dap_customer.userLastName}
                  </td>
                </tr>
                <tr>
                  <th>Industry</th>
                  <td>{dap_customer.industry}</td>
                </tr>
                <tr>
                  <th>City</th>
                  <td>{dap_customer.city}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="card">
          {/* <h4></h4> */}
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th>Partner</th>
                <td>
                  {dap_partner.userFirstName + " " + dap_partner.userLastName}{" "}
                </td>
              </tr>
              <tr>
                <th>Location</th>
                <td>{dap_device.deviceLon} </td>
              </tr>
              <tr>
                <th>AccessToken</th>
                <td>{dap_device.accessToken} </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <div className="card mt-2">
            <div className="card-body">
                <h4>Device History</h4>
                <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={journeyData}
                      columns={columns}
                      search>
                      {(props) => (
                        <div>
                          <BootstrapTable
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      )}
                </ToolkitProvider>
            </div>
        </div>  */}
      </div>
    </div>
  );
};

export default ViewDamageDeviceDetails;
